





















































export default {
	name: 'AppList',
	data() {
		return {
			searchService: '',
			value: 'all',
			customService: {
				id: 'custom',
				name: '',
				description: 'Add a custom app if is not listed above.',
				urls: ['___'],
				serviceId: 'custom',
			},
			categoriesArr: [],
			byCompany: [],
		};
	},
	computed: {
		categories(): object[] {
			return [
				{
					options: [
						{
							id: 'all',
							name: 'All',
						},
						{
							id: 'popular',
							name: 'Most popular',
						},
					],
				},
				{
					label: 'Categories',
					options: this.categoriesArr,
				},
				{
					label: 'By company',
					options: this.byCompany,
				},
			];
		},
		services(): object[] {
			let s: object[] = [];
			this.$store.state.allServices.forEach(serv => {
				switch (this.value) {
					case 'all':
						(this.searchService === '' || serv.name.toLowerCase().search(this.searchService.toLowerCase()) !== -1) &&
							s.push(serv);
						break;
					default:
						serv.category.includes(this.value) &&
							(this.searchService === '' || serv.name.toLowerCase().search(this.searchService.toLowerCase()) !== -1) &&
							s.push(serv);
				}
			});
			return s;
		},
	},
	methods: {
		doClearSearch(e) {
			this.searchService = '';
		},
		onSelectService(service) {
			this.$emit('selectedService', service);
		},
		doSelectOnEnter() {
			if (this.services.length === 1) {
				this.$emit('selectedService', this.services[0]);
				this.doClearSearch();
			}
		},
	},
	mounted() {
		setTimeout(() => this.$refs.search && this.$refs.search.focus(), 200);
		this.$store.state.categories.forEach(category => {
			category.hasOwnProperty('company') ? this.byCompany.push(category) : this.categoriesArr.push(category);
		});
	},
};
